<template>
  <div>
    <Grid
      :service="service"
      route_name="product_revenue"
      route_grid_path="/grid"
      order_column="total_revenue"
      direction="desc"
      :show-export="true"
      :export-types="['csv', 'xls']"
      export-filename="hubee_product_revenue"
      :fetch-on-mounted="false"
      hide_actions="true"
      hide_searchbar="true"
      ref="grid"
    >
      <template v-slot:filterZone>
        <FinancialPeriodFilter
          v-model="filters"
          @change="handleFilterChange"
          :show-product-filter="true"
          :show-institution-filter="true"
        />
      </template>

      <template v-slot:gridThead>
        <vs-th key="name" sort-key="name">Produto</vs-th>
        <vs-th key="type" sort-key="type">Tipo</vs-th>
        <vs-th key="total_quantity" sort-key="total_quantity"
          >Quantidade Vendida</vs-th
        >
        <vs-th key="total_orders" sort-key="total_orders"
          >Total de Pedidos</vs-th
        >
        <vs-th key="total_revenue" sort-key="total_revenue"
          >Receita Total</vs-th
        >
        <vs-th key="avg_order_value" sort-key="avg_order_value"
          >Ticket Médio</vs-th
        >
      </template>

      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="25%" key="name">
            <div class="font-semibold">{{ tr.name }}</div>
          </vs-td>
          <vs-td width="10%" key="type">
            <div>{{ formatProductType(tr.type) }}</div>
          </vs-td>
          <vs-td width="13%" key="total_quantity">
            <div>{{ tr.total_quantity }}</div>
          </vs-td>
          <vs-td width="13%" key="total_orders">
            <div>{{ tr.total_orders }}</div>
          </vs-td>
          <vs-td width="20%" key="total_revenue">
            <span class="font-semibold text-success">{{
              formatCurrency(tr.total_revenue)
            }}</span>
          </vs-td>
          <vs-td width="19%" key="avg_order_value">
            <div>{{ formatCurrency(tr.avg_order_value) }}</div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import FinancialPeriodFilter from '@/components/filters/FinancialPeriodFilter.vue'
import ProductRevenueService from '@/services/api/ProductRevenueService'
import { currencyFormatter } from '@/util/Util'

export default {
  name: 'ProductRevenueIndex',
  components: {
    Grid,
    FinancialPeriodFilter
  },
  data() {
    return {
      service: null,
      filters: {
        institution_id: null,
        start_date: null,
        end_date: null,
        product_id: null
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return currencyFormatter(value)
    },
    formatProductType(type) {
      const typeMap = {
        LES: 'Aula',
        RSP: 'Espaço para Aluguel',
        MIX: 'Misto'
      }
      return typeMap[type] || type || 'N/A'
    },
    handleFilterChange(filters) {
      this.filters = filters
      this.updateFilters()
    },
    updateFilters() {
      const customFilters = {}

      if (this.filters.institution_id) {
        customFilters.institution_id = this.filters.institution_id
      }

      if (this.filters.start_date) {
        customFilters.start_date = this.filters.start_date
      }

      if (this.filters.end_date) {
        customFilters.end_date = this.filters.end_date
      }

      if (this.filters.product_id) {
        customFilters.product_id = this.filters.product_id
      }

      // Limpar todos os custom_filters primeiro
      this.$refs.grid.custom_filters = []

      // Preencher apenas os filtros que têm valores
      if (Object.keys(customFilters).length > 0) {
        this.$refs.grid.fillCustomFilters(
          Object.keys(customFilters).map(key => ({
            key,
            value: customFilters[key]
          }))
        )
      }

      this.$refs.grid.fetchGridData(true)
    }
  },
  beforeMount() {
    this.service = ProductRevenueService.build(this.$vs)
  }
}
</script>

<style scoped>
.vs-select {
  min-width: 200px;
}
</style>
